import { FC } from "react"
import { Navigate } from "react-router-dom"

const LoanOfficerDashboardPage: FC<{}> = () => {
  // Redirect to Engagements page for now
  return <Navigate to="/engagements" replace />
}

export default LoanOfficerDashboardPage
